import { useMemo } from 'react';
import { Store } from '../codegen/graphql';
import {
    getDefaultApplicableTo,
    getEligibleAdvertisingZoneStores,
} from '../helpers/storeSelectionHelper';

export function useEligibleAdvertisingZoneStores(
    advertisingZoneStores: Store[] | null | undefined,
) {
    const eligibleZoneStores = useMemo(
        () => getEligibleAdvertisingZoneStores(advertisingZoneStores),
        [advertisingZoneStores],
    );
    const eligibleZoneStoreIds = useMemo(
        () => eligibleZoneStores.map(store => store.id),
        [eligibleZoneStores],
    );
    const hasEligibleZoneStores = eligibleZoneStores.length > 0;
    const defaultApplicableTo = getDefaultApplicableTo(hasEligibleZoneStores);

    return {
        eligibleZoneStores,
        eligibleZoneStoreIds,
        hasEligibleZoneStores,
        defaultApplicableTo,
    };
}
